module.exports = __webpack_public_path__ + "static/media/title.3d4195ed.svg";